import React, { useContext, useState, useEffect } from 'react';
import { Container } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';
import { Link } from 'react-scroll';
import PortfolioContext from '../../context/context';
import HeaderImg from '../Image/HeaderImg';

const Header = () => {
  const { hero, footer } = useContext(PortfolioContext);
  const { title, name, subtitle, cta } = hero;
  const { networks } = footer;

  const [isDesktop, setIsDesktop] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (window.innerWidth > 769) {
      setIsDesktop(true);
      setIsMobile(false);
    } else {
      setIsMobile(true);
      setIsDesktop(false);
    }
  }, []);

  return (
    <section id="hero" className="jumbotron justify-content-center">
      <div>
        <Container >
          <div >
            <HeaderImg alt="header picture" filename="header.png" />
          </div>
          <Fade left={isDesktop} bottom={isMobile} duration={500} delay={500} distance="30px">
            <h1 className="hero-title">
              {title }{' '}
              <span className="text-color-main">{name}</span>
              <img src="https://github.githubassets.com/images/icons/emoji/unicode/1f44b.png"/>
              <br />
              {subtitle}
            </h1>
          </Fade>
          <div className="social-links">
          {networks &&
            networks.map((network) => {
              const { id, name, url } = network;
              return (
                <a
                  key={id}
                  href={url}
                  rel="noopener noreferrer"
                  target="_blank"
                  aria-label={name}
                >
                  <i className={`fa fa-${name} `} />
                </a>
              );
            })}
        </div>
          <Fade left={isDesktop} bottom={isMobile} duration={1000} delay={1000} distance="30px">
            <p className="hero-cta">
                <Link to="about" smooth duration={1000} className="cta-btn cta-btn--hero">
                  {cta || 'Know more'}
                </Link>
            </p>
          </Fade>
        </Container>
      </div>
    </section>
  );
};

export default Header;
